import type { DeploymentStage } from '../Overview'

type Counts = {
  totalLocationsCount?: number
  activeLocationsCount?: number
  guestFacingTotalLocationsCount?: number
  guestFacingActiveLocationsCount?: number
}

export type Coverage = {
  total?: number
  active?: number
  isGuestFacing: boolean
}

// The single source of location coverage for the Overview stage, the "N of M
// locations" header, and the "Turn on at more locations" billboard, so all
// three agree. Guest-facing counts (standard-visibility stores only) win when
// the backend sends BOTH; otherwise fall back to the merchant-visible counts.
export const resolveCoverage = ({
  totalLocationsCount,
  activeLocationsCount,
  guestFacingTotalLocationsCount,
  guestFacingActiveLocationsCount,
}: Counts): Coverage => {
  if (
    guestFacingTotalLocationsCount != null &&
    guestFacingActiveLocationsCount != null
  ) {
    return {
      total: guestFacingTotalLocationsCount,
      active: guestFacingActiveLocationsCount,
      isGuestFacing: true,
    }
  }
  return {
    total: totalLocationsCount,
    active: activeLocationsCount,
    isGuestFacing: false,
  }
}

// Pure routing for the Overview tab, on resolveCoverage. Guest-facing: none
// (active 0) / full (active >= total) / pilot. Legacy fallback: full iff active
// has caught up to a positive total, else the conservative pilot default (also
// the loading state) — never `none`, since the merchant-visible counts include
// staff-only stores.
export const resolveDeploymentStage = (counts: Counts): DeploymentStage => {
  const { total, active, isGuestFacing } = resolveCoverage(counts)

  if (isGuestFacing && total != null && active != null) {
    if (active === 0) {
      return 'none'
    }
    return active >= total ? 'full' : 'pilot'
  }

  return total != null && total > 0 && active === total ? 'full' : 'pilot'
}
